import styled from 'styled-components';
import { colors } from 'styles/colors';

export const FormModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SelectInput = styled.input`
  min-height: 48px;
  margin: 0;
  font-size: 12px;
  color: #000;
  width: 100%;
  border-radius: 5px;
  box-sizing: border-box !important;
  display: inline-flex;
  border: 0.7px solid ${colors.GreyInputBorder};
`;

export const ModalOverlay = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${colors.neutral[900]}50;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: white;
  width: 856px;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  gap: 10px;
  flex-direction: column;

  @media (max-width: 768px) {
    height: 90vh;
    width: 80%;
    margin: 0 24px;
    overflow: hidden;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  font-size: 20px;
  line-height: 150%;

  h3 {
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    color: ${colors.text['main-900']};
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 20px;
  align-self: flex-start;
  display: flex;
  padding: 6px;
`;

export const ModalContent = styled.div`
  display: flex;

  @media (max-width: 768px) {
    overflow-y: auto;
  }
`;
